<div class="mb-4" *ngIf="fb && fb.error">
    <lib-error [title]="fb.text" [error]="fb.error"></lib-error>
</div>

<ng-container *ngIf="state == 3; else notLoading">
  <div class="col-12 text-center mb-4">
    <lib-loading [status]="'text-primary'" [spinnerPosition]="true" [text]="'LDG'" [size]="'md'">
    </lib-loading>
  </div>
</ng-container>

<ng-template #notLoading>
  <ng-container *ngIf="state == 0">

    <p class="mb-4"><b>Customer address is required before this customer can be created in jControl</b></p>

    <form [formGroup]="form" *ngIf="form?.controls">
      <div class="row">
        <div class="col-12">
          <app-address-search-box [formGroup]="form" [allowEditForm]="true"
            [countryLookup]="form.controls.country.value" (countrySelected)="setCountrySelected($event)"
            [countries]="countries" [parentFormSubmitted]="formSubmitted" (isAddressVerifiedOrOverruled)="updateIsAddressVerifiedOrOverruledState($event, form)">
          </app-address-search-box>
        </div>
      </div>
      <div class="row check-box-container">
        <div class="col-12 col-lg-6 pl-0">
          <lib-check-box [control]="form.controls.isResidentialAddress" [idName]="'residential_address'"
            [label]="'Residential Address'">
          </lib-check-box>
          <lib-check-box [control]="form.controls.isDefault" [idName]="'default-address'" [label]="'Default Address'">
          </lib-check-box>
          <div class="msg-container" *ngIf="!canDefault">
            <div class="msg d-flex justify-content-center align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                class="bi bi-exclamation-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path
                  d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z" />
              </svg>
              <small class="ml-1">This address will become the default address.</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 pl-0 mb-3">
          <lib-check-box [control]="form.controls.isBillTo" [idName]="'bill-address'" [label]="'Bill Address'">
          </lib-check-box>
          <lib-check-box [control]="form.controls.isBillToDefault" [idName]="'bill-default-address'"
            [label]="'Bill To Default Address'">
          </lib-check-box>
          <div class="msg-container" *ngIf="!canBillTo">
            <div class="msg d-flex justify-content-center align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                class="bi bi-exclamation-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path
                  d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z" />
              </svg>
              <small class="ml-1">This address will become the default billing address.</small>
            </div>
          </div>
          <lib-check-box [control]="form.controls.isShipTo" [idName]="'ship-to-address'" [label]="'Ship To Address'">
          </lib-check-box>
          <lib-check-box [control]="form.controls.isShipToDefault" [idName]="'ship-default-address'"
            [label]="'Ship To Default Address'">
          </lib-check-box>
          <div class="msg-container" *ngIf="!canShipTo">
            <div class="msg d-flex justify-content-center align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                class="bi bi-exclamation-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path
                  d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z" />
              </svg>
              <small class="ml-1">This address will become the default ship to address.</small>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="required-fields-container">
            <lib-required-fields [formGroup]="form"></lib-required-fields>
          </div>
          <div class="button-container">
            <button (click)="save(form)" class="btn btn-success ml-4">Save & Continue</button>
          </div>
        </div>
      </div>
    </form>
  </ng-container>

  <ng-container *ngIf="state == 1">

    <p class="mb-4"><b>Customer has missing address details that are required before this customer can be created in
        jControl</b></p>

    <form [formGroup]="form" *ngIf="form?.controls">
      <div class="row">
        <div class="col-12">
          <ng-container *ngIf="countries && countries.length > 0">
            <app-address-search-box [formGroup]="addressDetails()" [allowEditForm]="true" [mode]="1"
              [countryLookup]="addressDetails().controls.country.value" (countrySelected)="setCountrySelected($event)"
              [countries]="countries" [parentFormSubmitted]="formSubmitted" (isAddressVerifiedOrOverruled)="updateIsAddressVerifiedOrOverruledState($event, form)">
            </app-address-search-box>
          </ng-container>
        </div>
      </div>
      <div class="row check-box-container">
        <div class="col-12 col-lg-6 pl-0">
          <lib-check-box [control]="addressDetails().controls.isResidentialAddress" [idName]="'residential_address'"
            [label]="'Residential Address'">
          </lib-check-box>
          <lib-check-box [control]="addressDetails().controls.isDefault" [idName]="'default-address'"
            [label]="'Default Address'">
          </lib-check-box>
          <div class="msg-container" *ngIf="!canDefault">
            <div class="msg d-flex justify-content-center align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                class="bi bi-exclamation-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path
                  d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z" />
              </svg>
              <small class="ml-1">This address will become the default address.</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 pl-0 mb-3">
          <lib-check-box [control]="addressDetails().controls.isBillTo" [idName]="'bill-address'"
            [label]="'Bill Address'">
          </lib-check-box>
          <lib-check-box [control]="addressDetails().controls.isBillToDefault" [idName]="'bill-default-address'"
            [label]="'Bill To Default Address'">
          </lib-check-box>
          <div class="msg-container" *ngIf="!canBillTo">
            <div class="msg d-flex justify-content-center align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                class="bi bi-exclamation-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path
                  d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z" />
              </svg>
              <small class="ml-1">This address will become the default billing address.</small>
            </div>
          </div>
          <lib-check-box [control]="addressDetails().controls.isShipTo" [idName]="'ship-to-address'"
            [label]="'Ship To Address'">
          </lib-check-box>
          <lib-check-box [control]="addressDetails().controls.isShipToDefault" [idName]="'ship-default-address'"
            [label]="'Ship To Default Address'">
          </lib-check-box>
          <div class="msg-container" *ngIf="!canShipTo">
            <div class="msg d-flex justify-content-center align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                class="bi bi-exclamation-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path
                  d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z" />
              </svg>
              <small class="ml-1">This address will become the default ship to address.</small>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="required-fields-container">
            <lib-required-fields [formGroup]="form"></lib-required-fields>
          </div>
          <div class="button-container">
            <button (click)="saveUpdatedAddress(form)" class="btn btn-success ml-4">Save & Continue</button>
          </div>
        </div>
      </div>
    </form>
  </ng-container>

  <ng-container *ngIf="state == 2">

    <p class="mb-4"><b>You must select a default address before this customer can be created in jControl</b></p>

    <form [formGroup]="form" *ngIf="form?.controls">
      <div class="row">
        <div class="col-12">
          <lib-select-box [control]="form.controls.defaultAddress" [source]="savedAddresses" [labelBlock]="true"
            [fieldDescription]="'concatenatedAddress'" [idName]="'saved addresses'" [label]="'Default Address:'">
          </lib-select-box>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="required-fields-container">
            <lib-required-fields [formGroup]="form"></lib-required-fields>
          </div>
          <div class="button-container">
            <button (click)="saveNewDefaultAddress(form)" class="btn btn-success ml-4" [autofocus]="true">Save &
              Continue</button>
          </div>
        </div>
      </div>
    </form>
  </ng-container>
</ng-template>
